import Vue from "vue";
import { ResponseWrapper, ErrorWrapper } from "./util";

export class BaseService {
  static get entity() {
    throw new Error("entity getter not defined");
  }
  static get name() {
    throw new Error("name getter not defined");
  }
  static get profile() {
    const profile = window.localStorage.getItem("perfil");
    return profile;
  }

  /**
   * The method used to perform an AJAX-request.
   *
   * @param {string}      requestType The request type.
   * @param {string}      url         The URL for the request.
   * @param {string|null} name        The name of the object response.
   * @param {Object|null} data        The data to be send with the request.
   * @param {Object|null} config      The config object to be sent with the request.
   *
   * @returns {Promise} The result in a promise.
   */
  static submit(requestType, url, name = null, data = null, config = null) {
    return new Promise((resolve, reject) => {
      let request;
      if (requestType === "get" || requestType === "delete") {
        // For GET/DELETE, config is the second argument
        request = Vue.$http2[requestType](url, config);
      } else {
        // For POST/PUT/PATCH, data is the second, config is third
        request = Vue.$http2[requestType](url, data, config);
      }
      request
        .then((response) => {
          let data = name ? response.data[name] : response.data;
          if (config == null) {
            resolve(data);
          } else {
            if (config.showResponseWrapper) {
              resolve(new ResponseWrapper(response, data));
            } else {
              resolve(data);
            }
          }
        })
        .catch(({ response }) => {
          if (response) {
            console.log(response);
            reject(new ErrorWrapper(response));
          } else {
            reject();
          }
        });
    });
  }

  /**
   * ------------------------------
   * @HELPERS
   * ------------------------------
   */

  static responseWrapper(...rest) {
    return new ResponseWrapper(...rest);
  }

  static errorWrapper(...rest) {
    return new ErrorWrapper(...rest);
  }

  /**
   * ----------------------------
   * BASIC API CALLS
   * ----------------------------
   */

  static async getAll() {
    return this.submit("get", `${getApiUrlEntity(this.profile)}${this.entity}`, this.name);
  }

  static async getById(id) {
    return this.submit("get", `${getApiUrlEntity(this.profile)}${this.entity}/${id}`, this.name);
  }

  static async create(data = {}, config = {}) {
    return this.submit("post", `${getApiUrlEntity(this.profile)}${this.entity}`, this.name, data, config);
  }

  static async update(id, data = {}) {
    return this.submit("put", `${getApiUrlEntity(this.profile)}${this.entity}/${id}`, this.name, data);
  }

  static async remove(id) {
    return this.submit("delete", `${getApiUrlEntity(this.profile)}${this.entity}/${id}`, this.name);
  }

  static async getTrash() {
    return this.submit("get", `${getApiUrlEntity(this.profile)}${this.entity}/trash`, this.name);
  }

  static async restore(id) {
    return this.submit("delete", `${getApiUrlEntity(this.profile)}${this.entity}/activate/${id}`, this.name);
  }
  static async findByNodeIdOnSchedule(node_id) {
    return this.submit("get", `${getApiUrlEntity(this.profile)}${this.entity}/find_by_node_id_on_schedule/${node_id}`, this.name);
  }

  static getApiUrlEntity(entity) {
    if (process.env.VUE_APP_SHOW_ENTITY === "true") {
      return `${entity}/`;
    }
    return "";
  }
}
